export default "__VITE_ASSET__kBYC_Usl__"